import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import { store } from "./redux/store";
import "./App.css";
import MainLayout from "./layouts/mainLayout";
import ProtectedRoute from "./components/protectedRoute";
import Products from "./pages/products";
import BusinessUnit from "./pages/businessUnit";
import UserApi from "./pages/UserApiKey";
import SystemAlert from "./pages/systemAlert";
import DbAdmin from "./pages/DBAdmin";
import Login from "./pages/login";
import UserProfile from "./pages/userProfile";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from ".";

const LayoutRoute = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const allRoutes = [
  { path: "/Products", element: <Products /> },
  { path: "/BusinessUnit", element: <BusinessUnit /> },
  { path: "/UserApiKey", element: <UserApi /> },
  { path: "/SystemAlert", element: <SystemAlert/> },
  { path: "/DbAdmin", element: <DbAdmin/> },
];

const AppRoutes = () => {
  const allowedRoutes = useSelector((state) => state?.user?.allowedRoutes || []);
  console.log('app routes', allowedRoutes);


  const RedirectToFirstAllowed = () => {
    console.log('app routes redirect', allowedRoutes);
    if (!allowedRoutes.length || typeof allowedRoutes[0] !== "string") {
      console.log('redirect login');
      return <Navigate to="/login" replace />;
    }
    console.log('allowedRoutes[0]', allowedRoutes[0]);
    return <Navigate to={allowedRoutes[0]} replace />;
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/userProfile" element={<UserProfile />} />
      {allRoutes
        .filter(({ path }) => allowedRoutes.includes(path))
        .map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={
              <LayoutRoute>{element}</LayoutRoute>
            }
          />
      ))}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RedirectToFirstAllowed />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <RedirectToFirstAllowed />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <Router>
          <AppRoutes />
        </Router>
      </Provider>
    </MsalProvider>
  );
}

export default App;
